import {BaseModel} from "../base-model";
import {TermsUtils} from "../../utils/terms-utils";
import {IOC} from "../../ioc";
import {Type} from "../../type";

export class BaseRouteMetaDataModel extends BaseModel {
  ioc: IOC;

  constructor(ioc: IOC) {
    super();

    this.ioc = ioc;
  }

  get termsUtils(): TermsUtils {
    return this.resolve(TermsUtils);
  }

  get pageTitle(): String { return null }

  get description(): String { return null }

  resolve(type: Type): Type {
    return this.ioc.getInstance(type);
  }

  get isNoIndex(): Boolean {
    return false;
  }
}
